<c-container fluid>
    <c-row class="justify-content-center mt-5">
        <c-col xs="12" md="8" lg="6">
            <c-card>
                <c-card-body class="text-center p-5">
                    <!-- Loading -->
                    @if (loading()) {
                        <c-spinner color="primary"></c-spinner>
                    }
                    <!-- Error -->
                    @if (error()) {
                        <c-alert color="danger">
                            {{ error() }}
                        </c-alert>
                    }
                </c-card-body>
            </c-card>
        </c-col>
    </c-row>
</c-container>